export const signs = [
  { id: "museum-006", location: "Museum Garden Level", aspectRatio: "16:9" },
  { id: "museum-102", location: "Museum Entry Pavilion", aspectRatio: "44:9" },
  { id: "museum-110", location: "Museum Plaza Level (Tower Lobby A)", aspectRatio: "9:32" },
  { id: "museum-113", location: "Museum Plaza Level (Tower Lobby)", aspectRatio: "9:32" },
  { id: "museum-114", location: "Museum Plaza Level (Tower Lobby C)", aspectRatio: "9:32" },
  {
    id: "museum-195",
    location: "Museum Plaza Level M (Plaza Mezz North 195)",
    aspectRatio: "9:32"
  },
  { id: "museum-200", location: "Museum Level 2 (L2 Entry Hall 200)", aspectRatio: "9:32" },
  { id: "museum-250", location: "Museum Level 2M (L2M Lobby 250)", aspectRatio: "9:32" },
  { id: "museum-271", location: "Library Level 2M (L2 271)", aspectRatio: "9:32" },
  { id: "museum-300", location: "Museum Level 3 (L3 Entry Hall 300)", aspectRatio: "9:32" },
  { id: "museum-400", location: "Museum Level 4 (L4 Entry Hall 400)", aspectRatio: "9:32" },
  { id: "museum-450", location: "Musuem Level 4M (L4M Lobby 450)", aspectRatio: "9:32" },
  { id: "museum-500", location: "Museum Level 5 (L5 Entry Hall 500)", aspectRatio: "9:32" },
  { id: "museum-800", location: "Museum Sky Room (800)", aspectRatio: "9:32" },
  { id: "museum-800a", location: "Museum Sky Room (800A)", aspectRatio: "9:32" },
  { id: "forum-121-1", location: "Winter Garden Entrance", aspectRatio: "32:9" },
  { id: "forum-121-2", location: "Outside Auditorium", aspectRatio: "16:9" },
  { id: "forum-121-3", location: "Outside Restaurant", aspectRatio: "32:9" },
  { id: "forum-001", location: "Forum LL (Tower Lobby A 001)", aspectRatio: "9:32" },
  { id: "forum-020a", location: "Forum LL (Forum Lobby 020A)", aspectRatio: "9:32" },
  { id: "forum-021a", location: "Forum LL (Studio Sound Lock 021A)", aspectRatio: "16:9" },
  { id: "forum-020b", location: "Forum LL (020B)", aspectRatio: "16:9" },
  { id: "ac-102", location: "Athletic Center Level 1 (Reception Desk 102)", aspectRatio: "32:9" },
  {
    id: "ac-e106",
    location: "Athletic Center Level 1 (Next to Corridor 124)",
    aspectRatio: "9:32"
  },
  {
    id: "ac-e122",
    location: "Athletic Center Level 1 (South end of Corridor 124)",
    aspectRatio: "9:32"
  },
  { id: "ac-e201", location: "Athletic Center Level 2 (Corridor 200A)", aspectRatio: "9:32" },
  { id: "ac-e204", location: "Athletic Center Level 2 (South Stair S205)", aspectRatio: "9:32" },
  { id: "cpl-140", location: "CPL (Vestibule 140)", aspectRatio: "9:32" },
  { id: "plaza-north", location: "Plaza North", aspectRatio: "9:16" },
  { id: "plaza-south", location: "Plaza South", aspectRatio: "9:16" }
];
